module.exports = __webpack_public_path__ + "images/emoji/ledger.ce512d8e1b050ed5ad29.png";